import { useCart } from "../store/hooks/useCart";
import { useCartSelections } from "../store/hooks/useCartSelections";

export const useHasSelectedProducts = (): boolean => {
  const cart = useCart();
  const cartSelections = useCartSelections();

  if (cart || cartSelections) {
    return true;
  }

  return false;
};
